export default "__VITE_ASSET__DIJ0HEvT__"